module.exports = __webpack_public_path__ + "img/weather.e8ea1422.svg";